












import Vue from 'vue';

export default Vue.extend({
    mounted() {
        this.$ui.hideHeader();
    },
    destroyed() {
        this.$ui.showHeader();
    },
});
